import script from "./UserManualSignUp.vue?vue&type=script&setup=true&lang=js"
export * from "./UserManualSignUp.vue?vue&type=script&setup=true&lang=js"

import "./UserManualSignUp.vue?vue&type=style&index=0&id=71f9dd90&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71f9dd90"]])

export default __exports__